module.exports = __webpack_public_path__ + "img/image8@2x.5c3da3c7.png";